import { useState } from "react";
import { Button } from "V2.0/common/button";
import { Switch } from "V2.0/common/switch";
import InputComponent from "V2.0/components/InputComponent";

function HelloResponsesEnableSwitch(props) {
  const { isHelloResponsesEnabled, onUpdate, disabled } = props;

  function handleUpdateHelloResponses() {
    onUpdate({
      helloResponsesEnabled: !isHelloResponsesEnabled,
    });
  }

  return (
    <Switch
      color="green"
      disabled={disabled}
      checked={isHelloResponsesEnabled}
      onChange={handleUpdateHelloResponses}
    />
  );
}

export default function HelloResponses(props) {
  const { voiceCache, onSave, locked } = props;

  const [settings, setSettings] = useState({
    helloResponsesEnabled: voiceCache.helloResponsesEnabled,
    helloResponses: voiceCache.helloResponses,
  });

  function handleUpdate(updatedSetting) {
    setSettings((prevSettings) => {
      return {
        ...prevSettings,
        ...updatedSetting,
      };
    });
  }

  function handleUpdateHelloResponses(e) {
    setSettings((prevSettings) => {
      return {
        ...prevSettings,
        helloResponses: e.target.value,
      };
    });
  }

  function handleSave() {
    const transformedResponses = Array.isArray(settings.helloResponses)
      ? settings.helloResponses
      : settings.helloResponses.split(",");
    onSave({
      ...settings,
      helloResponses: transformedResponses,
    });
  }

  return (
    <div className="border rounded-lg w-full">
      <div className="bg-gray-50 px-6 py-4 rounded-t-lg space-y-2">
        <p className="text-base font-medium">Query Fillers</p>
        <p className="text-sm text-gray-500">
          Short phrases (e.g., “Yeah?”, “I’m here”) the assistant uses to show
          it’s listening or ready for input.
        </p>
      </div>
      <div className="px-8 py-4 grid grid-cols-3 space-y-4">
        <div className="col-span-3 flex items-center gap-x-2">
          <p className="font-medium">Use Query Fillers</p>
          <HelloResponsesEnableSwitch
            isHelloResponsesEnabled={settings.helloResponsesEnabled}
            onUpdate={handleUpdate}
            disabled={locked}
          />
        </div>

        <div className="col-span-3 xl:col-span-2 ml-4">
          <InputComponent
            type="textArea"
            label="Enter Fillers (comma-seperated)"
            placeholder="Yes, I'm here.,I hear you,"
            disabled={locked || !settings.helloResponsesEnabled}
            onChange={handleUpdateHelloResponses}
            value={settings.helloResponses}
            style={{ height: "100px", fontSize: "13px" }}
          />
        </div>
      </div>
      <div className="bg-gray-50 px-6 py-3 text-right rounded-b-lg">
        {!locked && <Button onClick={handleSave}>Save</Button>}
      </div>
    </div>
  );
}
